import { makeAutoObservable } from 'mobx';
import { createUUID } from 'utils/helpers';

type Error = {
	id: string;
	type: string;
	message: string;
};

interface IAddError {
	type: string;
	message: string;
}

export class ErrorsStore {
	errors: Array<Error> = [];
	serverError: boolean = false;

	constructor() {
		makeAutoObservable(this);
	}

	add({ type, message }: IAddError): void {
		const id = createUUID();
		this.errors.push({ id, type, message });
	}

	remove(id: string): void {
		const index = this.errors.map((item) => item.id).indexOf(id);

		if (index > 0) {
			this.errors.splice(index, 1);
		}
	}

	clear(): void {
		this.errors = [];
	}

	setServerError() {
		this.serverError = true;
	}
}
